import AppConfig from '~/utils/appconfig';

/**
 * Create and initialize MSAL instance
 */
export const createMsalInstance = async () => {
    const { PublicClientApplication, EventType } = await import(
        '@azure/msal-browser'
    );

    const msalInstance = new PublicClientApplication({
        auth: {
            clientId: AppConfig.clientId,
            authority: AppConfig.authority,
            redirectUri: '/',
            postLogoutRedirectUri: '/',
            navigateToLoginRequestUrl: false, // Prevent redirect loops
        },
    });

    await msalInstance.initialize();
    await msalInstance.handleRedirectPromise();

    // Set logged-in account as the active account, if login was successful
    msalInstance.addEventCallback((event) => {
        if (
            (event.eventType === EventType.LOGIN_SUCCESS ||
                event.eventType === EventType.SSO_SILENT_SUCCESS) &&
            event.payload
        ) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const payload = event.payload as any;
            const account = payload.account;
            if (account) {
                msalInstance.setActiveAccount(account);
            }
        }
    });

    // Set active account if accounts exist
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0) {
        msalInstance.setActiveAccount(accounts[0]);
    }

    return msalInstance;
};

export const isMsalEnabled = (): boolean => {
    const msalDisabled = import.meta.env.VITE_MSAL_DISABLED === 'true';
    return !msalDisabled && !!AppConfig.clientId && !!AppConfig.authority;
};
